import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import TopNav from './components/TopNav';
import BoasVindas from './pages/BoasVindas';
import ModeLogin from './pages/ModeLogin';
import ModelFunnel from './pages/ModelFunnel';
import ModelDashboard from './pages/ModelDashboard';
import ModelSettings from './pages/ModelSettings';

// Componente que envolve as rotas e o TopNav
function AppContent() {
  const location = useLocation();
  const { currentUser } = useAuth();
  
  // Lista de rotas que não devem mostrar o TopNav
  const publicRoutes = ['/', '/login', '/funnel/:username'];
  const shouldShowNav = currentUser && !publicRoutes.includes(location.pathname);

  return (
    <div className="min-h-screen bg-gray-50">
      {shouldShowNav && <TopNav />}
      <div className={shouldShowNav ? "pt-16" : ""}>
        <Routes>
          <Route path="/" element={<BoasVindas />} />
          <Route path="/login" element={<ModeLogin />} />
          <Route path="/funnel/:username" element={<ModelFunnel />} />
          <Route path="/dashboard/:username" element={<ModelDashboard />} />
          <Route path="/settings/:username" element={<ModelSettings />} />
          {/* Rota padrão para username */}
          <Route path="/:username" element={<ModelFunnel />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App; 